// local imports
import relativeApiFetch from "../../../utils/relative-api-fetch";

function sendGoogleAnalyticsEvent(event, options = {}) {
  if (typeof gtag === "function") {
    // eslint-disable-next-line no-undef
    gtag("event", event, options);
  }
}

function sendYaMetrikaEvent(goal) {
  const counter = window[window.ya_counter_name];
  if (counter) {
    counter.reachGoal(goal);
  }
}

async function _sendAnalytics(data) {
  try {
    await relativeApiFetch("/api/analytics", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page: window.location.pathname,
        utmParams: window.portal.utmParams,
        ...data,
      }),
    });
  } catch (e) {
    console.error(e);
  }
}

/**
 * если качаем gdz, то категория (школьный предмет) должна быть включена в utm_medium
 * если качаем how-to, то articleUid должен быть включен в utm_medium
 * @param {object} options
 * @param {string} options.articleUid
 * @param {string} options.categoryUid
 * @param {string} options.softUid
 */
async function sendDownloadEvent({ categoryUid, goal, softUid }) {
  const isWrapper = goal?.includes("inst");

  const prefixedDownloadType = goal;
  const downloadType = prefixedDownloadType.replace("download-", "");
  const project = isWrapper ? "inst" : "app";

  _sendAnalytics({
    action: "download",
    article_category: categoryUid,
    download_type: downloadType,
    project,
    uid: softUid,
  });

  if (isWrapper) {
    sendGoogleAnalyticsEvent("target", { event_category: "download" });
    sendYaMetrikaEvent("download-target");

    if (!/YaBrowser/.test(window.navigator.userAgent)) {
      sendYaMetrikaEvent("download-not-yab");
    }
  }

  sendGoogleAnalyticsEvent(downloadType, { event_category: "download" });
  sendYaMetrikaEvent(prefixedDownloadType);
}

/**
 * project отправляем на странице статьи, но не каталога
 * для gdz project == inst, когда категория (школьный предмет) включена в utm_medium
 * для how-to project == inst, когда articleUid включен в utm_medium
 */
async function sendViewEvent() {
  const { articleUid, categoryUid } = window.portal;
  const isArticlePage = Boolean(articleUid);

  let project;

  if (isArticlePage) {
    const uidForUtmMedium = articleUid?.startsWith("gdz-") ? categoryUid : articleUid;
    const isWrapper = window.portal.utmParams?.utm_medium?.includes(uidForUtmMedium);
    project = isWrapper ? "inst" : "app";
  }

  _sendAnalytics({
    action: "view",
    ...(isArticlePage ? { articleUid, project } : {}),
  });
  sendGoogleAnalyticsEvent("page_view");
}

export {
  sendDownloadEvent,
  sendViewEvent,
  sendYaMetrikaEvent,
};